











import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import * as $ from 'jquery';
import LetterTrailTree from  '@/components/Cartable/LetterDetails/LetterTrail/LetterTrailTree.vue';
@Component({
    components:{LetterTrailTree}
})
export default class FullPageTrail extends Vue{

    
    @Prop() letterPossessionId?: string;
    @Prop() letterNo?: string;
    @Prop() isActive?: boolean;
    @Watch('isActive')
    onIsActiveChanged(nVal: boolean, oVal: boolean){
        if(nVal)
        {
            $(".trail-box").dimmer('show');
        }
        else
        {
            $(".trail-box").dimmer('hide');
        }
    }
    
    mounted(){
        $(".trail-box").dimmer({closable: false});
         if(this.isActive)
        {
            $(".trail-box").dimmer('show');
        }
        else
        {
            $(".trail-box").dimmer('hide');
        }
    }

    close(){
        this.$emit('close');
    }

 

}


